module.exports = __webpack_public_path__ + "static/media/ico-updatecalendar.290701e6.svg";